import { useState } from "react";
import { validateMobilePhoneNumber } from "../ValidationUtils";

/**
 * A custom hook used to validate phone number fields phoneprefix and phone in a form.
 *
 * @param {boolean} isRequired
 * @param {boolean} initialPrefixValid
 * @param {boolean} initialPhoneNumberValid
 * @param {boolean} strictMobilePhoneNumberValidation
 * @returns {object}
 */
const useFormPhoneNumberValidation = (
    isRequired = false, // TODO: Remove or implement required validation.
    initialPrefixValid = false,
    initialPhoneNumberValid = false,
    strictMobilePhoneNumberValidation = true
) => {
    const [phonePrefixValid, setPhonePrefixValid] = useState(initialPrefixValid);
    const [phoneValid, setPhoneValid] = useState(initialPhoneNumberValid);

    /**
     * Validate mobile phone number field
     *
     * @param {string} phonePrefix
     * @param {string} phoneNumber
     * @returns {boolean}
     */
    const validatePhone = (phonePrefix, phoneNumber) => {
        // Return true and skip validation if either field is empty
        if (!phonePrefix || !phoneNumber) {
            return true; // Don't set errors yet
        }

        if (strictMobilePhoneNumberValidation) {
            const valid = validateMobilePhoneNumber(phonePrefix, phoneNumber);
            setPhoneValid(valid);
            return valid;
        }

        setPhoneValid(true);
        return true;
    };

    /**
     * Validate mobile phone prefix field
     *
     * @param {string} phonePrefix
     * @param {string} phoneNumber
     * @returns {boolean}
     */
    const validatePhonePrefix = (phonePrefix, phoneNumber) => {
        // Return true and skip validation if either field is empty
        if (!phonePrefix || !phoneNumber) {
            return true; // Don't set errors yet
        }

        setPhonePrefixValid(true);

        // Validate the phone number if it's filled
        if (strictMobilePhoneNumberValidation) {
            const valid = validateMobilePhoneNumber(phonePrefix, phoneNumber);
            setPhoneValid(valid);
            return valid;
        }

        setPhoneValid(true);
        return true;
    };

    return {
        phonePrefixValid,
        phoneValid,
        validatePhonePrefix,
        validatePhone,
    };
};

export default useFormPhoneNumberValidation;
